var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarchandise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 87.775,
    viewBox: "0 0 78 87.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_640",
    x: 17.633,
    y: 0,
    width: 41.51,
    height: 52.51,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_638",
    x: 30.857,
    y: 26.449,
    width: 41.51,
    height: 52.51,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_641",
    x: 4.408,
    y: 26.449,
    width: 41.51,
    height: 52.51,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_639",
    x: 0,
    y: 52.897,
    width: 78,
    height: 34.878,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f6ea1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_581",
    "data-name": "Groupe 581",
    transform: "translate(-567 -684)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 684)",
    filter: "url(#Trac\\xE9_640)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_640-2",
    "data-name": "Trac\\xE9 640",
    d: "M671.51,684h-8.816v7.347h-5.878V684H648v23.51h23.51Zm-2.939,20.571h-5.878v-2.939h5.878Zm0,0",
    transform: "translate(-621.37 -684)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 684)",
    filter: "url(#Trac\\xE9_638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_638-2",
    "data-name": "Trac\\xE9 638",
    d: "M702,792v23.51h23.51V792h-8.816v7.347h-5.878V792Zm14.694,17.633h5.878v2.939h-5.878Zm0,0",
    transform: "translate(-662.14 -765.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 684)",
    filter: "url(#Trac\\xE9_641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_641-2",
    "data-name": "Trac\\xE9 641",
    d: "M617.51,792h-8.816v7.347h-5.878V792H594v23.51h23.51Zm-2.939,20.571h-5.878v-2.939h5.878Zm0,0",
    transform: "translate(-580.59 -765.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 684)",
    filter: "url(#Trac\\xE9_639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_639-2",
    "data-name": "Trac\\xE9 639",
    d: "M576,900v5.878h5.878v-1.469a1.47,1.47,0,0,1,1.469-1.469h45.306a1.47,1.47,0,0,1,1.469,1.469v1.469H636V900Zm0,0",
    transform: "translate(-567 -847.1)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarchandise);
export default __webpack_public_path__ + "static/media/marchandise.c743486484fb37c053725d90dc309f3d.svg";
export { ForwardRef as ReactComponent };